import { render, staticRenderFns } from "./ViewReceiversPage.vue?vue&type=template&id=c2174a3a&"
import script from "./ViewReceiversPage.vue?vue&type=script&lang=js&"
export * from "./ViewReceiversPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports